<template>
  <div class="body">
    <section class="privacy-content">
<!--      <span class="privacy-content-title">用户服务协议</span>-->
      <span>欢迎使用由上海移视网络科技有限公司（以下简称“移视科技”）提供的脉迩生活平台健康管理服务（以下简称“移视服务”或“服务”）！</span>
      <br>
      <span>提示：在使用服务之前，您应当认真阅读并遵守《用户服务协议》（以下简称“本协议”）以及《隐私政策条款》。</span>
      <br>
      <span><b>请您务必审慎阅读、充分理解各条款内容，</b>特别是免除或者限制责任的条款、争议解决和法律适用条款。免除或者限制责任的条款可能将以加粗字体显示，您应重点阅读。
                当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，或您按照激活页面提示填写信息、阅读并同意本协议且完成全部激活程序后，或您以其他移视允许的方式实际使用本服务时，即表示您已充分阅读、理解并接受本协议的全部内容，本协议即产生法律约束力。您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议的内容或者未获得移视对您问询的解答等理由，主张本协议无效，或要求撤销本协议。</span>
      <br>
      <b>一、 缔约主体</b><br>
      <span>本协议由通过脉迩生活健康管理服务平台（以下简称“服务平台”）移动客户端应用软件及其他方式（以下简称“软件”）使用移视服务的用户（以下简称“用户”或“您”）与上海移视网络科技有限公司共同缔结。</span>
      <br>
      <b>二、 协议内容和效力</b><br>
      <span>1.	本协议内容包括本协议正文及所有移视已经发布或将来可能发布的隐私政策、各项政策、规则、声明、通知、警示、提示、说明（以下简称“规则”）。前述规则为本协议不可分割的组成部分，与本协议正文具有同等法律效力。</span>
      <span>2.	移视有权根据需要不时制订、修改本协议及相关规则，变更后的协议和规则一经公布，立即取代原协议及规则并自动生效。如您不同意相关变更，应当立即停止使用移视服务，如您继续使用移视服务或进行任何服务平台活动，即表示您已接受经修订的协议和规则。</span>
      <br>
      <b>三、 服务内容</b><br>
      <span>1.	移视提供手机客户端（iOS和Android版本）和小程序服务软件，移视可能会不断丰富您使用本服务的终端、形式等（具体以移视提供的为准），如您已注册使用一种形式的服务，则可以以同一账号使用其他版本服务，本协议自动适用于您对所有版本的软件和服务的使用。</span>
      <span>2.	移视许可您对服务平台软件进行非排他性的使用，您可以制作本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息，本条及本协议其他条款未明示授权的其他一切权利仍由移视保留，您在行使这些权利时须另外取得移视的书面许可。移视如果未行使前述任何权利，并不构成对该权利的放弃或许可。</span>
      <span>3.	本服务内容包含用户健康计划（为用户制定7日或30日健康管理计划，包括通过我们提供的智能硬件进行心率测量、血压测量、体重BMI测量、吸烟控制、30分钟有氧运动监测管理）、健康图谱（根据用户的健康计划执行状况和健康档案的信息进行数据可视化展示，包括每日得分和扣分，以此为依据绘制图表）、智能监测（心律失常监测、心脏负荷监测、血压监测，完成监测后会生成可视化报告，其中两项心脏相关智能监测可以在智能报告生成后，用户申请医生远程判读测量报告）、健康计划执行状况查看（可以查看每天已执行、待执行、未执行的健康计划执行状况，也可以查看其他未在执行中的，针对其他症状的健康计划介绍）、图文信息流（分为明星医生和医疗咨询，推送相关文章）、健康档案（收集用户已经完成的系列健康计划，并提供查看功能、用户过往测量的智能报告，包括心率和血压，以及用户过往申请的远程判读报告）等功能，这些功能服务可能根据公司运营策略的变化、用户需求的变化，随着因服务版本不同、或服务提供方的单方判断而被优化或修改，或因定期、不定期的维护而暂缓提供。</span>
      <span>4.	同时，移视保留在任何时候自行决定对服务或服务任何部分及其相关功能、应用软件变更、升级、修改、转移的权利。您同意，对于上述行为，移视均不需要进行通知，并且对您和任何第三人不承担任何责任。</span>
      <br>
      <b>四、 注册及账号管理</b><br>
      <span>1.	您确认，在您完成注册程序或以其他移视允许的方式实际使用服务时，您应当是具备完全民事权利能力和与所从事的民事行为相适应的行为能力的自然人、法人或其他组织。若您不具备前述主体资格，请勿使用服务，否则您及您的监护人应承担因此而导致的一切后果，且移视有权注销（永久冻结）您的账户，并向您及您的监护人索赔。如您代表一家公司或其他法律主体进行注册或以其他移视允许的方式实际使用本服务，则您声明和保证，您有权使该公司或该法律主体受本协议“条款”的约束。</span>
      <span>2.	您注册时应提交真实、准确、完整和反映当前情况的身份及其他相关信息，您可以使用您提供或确认的手机号或者移视允许的其它方式作为账号进行注册，。您理解并同意，您承诺注册的账号名称、设置的昵称、头像和简介等信息中不得出现违法和不良信息，不得冒充他人进行注册，不得未经许可为他人注册，不得以可能导致其他用户误认的方式注册账号或设置昵称，不得使用可能侵犯他人权益的昵称、图片（包括但不限于涉嫌商标权、著作权、名誉权侵权等），否则移视有权不予注册或停止服务并收回账号及服务平台用户号，因此产生的损失由您自行承担。</span>
      <span>3.	您了解并同意，服务平台注册账号所有权归属于移视，注册完成后，您仅获得账号使用权。账号使用权仅归属于初始申请注册人，不得以任何方式转让或被提供予他人使用，否则，移视有权立即不经通知收回该账号，由此带来的因您使用本服务产生的全部数据、信息等被清空、丢失等的损失，您应自行承担。</span>
      <span>4.	在您成功注册后，移视将根据账号和密码确认您的身份。您应妥善保管您的终端设备及账户和密码，并对利用该账户和密码所进行的一切活动（包括但不限于网上点击同意或提交各类规则协议、绑定智能设备、购买商品/服务、发表/回复话题、添加图片等）负全部责任。您承诺，在密码或账户遭到未获授权的使用，或者发生其他任何安全问题时，将立即通知移视，且您同意并确认，移视不对上述情形产生的任何直接或间接的遗失或损害承担责任。除非有法律规定或司法裁定，且征得移视的同意，否则，您的账户、密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。</span>
      <span>5.	您成功注册服务平台账号并进行首次使用时，应当根据您在服务平台或微商场采购的服务套餐，进行二维码验证，实现服务兑换。您成功兑换套餐服务后，方可开始使用您采购的服务。首次使用平台服务后，您可直接在服务平台进行余额充值或直接采购服务套餐。</span>
      <span>6.	您了解并同意，如您注册服务平台账号后连续超过12个月未登录，移视为服务平台优化管理之目的有权回收该账号，相关问题及责任均由您自行承担。</span>
      <span>7.	移视根据本协议收回或取消账号后，有权自行对账号相关内容及信息以包括但不限于删除等方式进行处理，且无需就此向用户承担任何责任。</span>
      <br>
      <br>
      <b>五、 服务使用规范</b><br>
      <span>1.	用户充分了解并同意，移视仅为用户提供服务平台，您应自行对利用服务从事的所有行为及结果承担责任。相应地，您应了解，使用移视服务可能发生来自他人非法或不当行为（或信息）的风险，您应自行判断及行动，并自行承担相应的风险。</span>
      <span>2.	您应自行承担因使用服务所产生的费用，包括但不限于上网流量费、通信服务费等。</span>
      <span>3.	除非另有说明，本协议项下的服务只能用于非商业用途。您承诺不对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于包括但不限于广告及任何其它商业目的。</span>
      <span>4.	您承诺不会利用本服务进行任何违法或不当的活动，包括但不限于下列行为:</span>
      <span>(1)	上载、传送或分享含有下列内容之一的信息：</span>
      <span>a)	反对宪法所确定的基本原则的；</span>
      <span>b)	危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
      <span>c)	损害国家荣誉和利益的；</span>
      <span>d)	煽动民族仇恨、民族歧视、破坏民族团结的；</span>
      <span>e)	破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
      <span>f)	散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
      <span>g)	散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
      <span>h)	侮辱或者诽谤他人，侵害他人合法权利的；</span>
      <span>i)	含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</span>
      <span>j)	含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；</span>
      <span>(2)	冒充任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；</span>
      <span>(3)	伪造标题或以其他方式操控识别资料，使人误认为该内容为移视或其关联公司所传送；</span>
      <span>(4)	将依据任何法律或合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以上载、传送或分享；</span>
      <span>(5)	将涉嫌侵害他人权利（包括但不限于著作权、专利权、商标权、商业秘密等知识产权、肖像权等）之内容上载、传送或分享；</span>
      <span>(6)	跟踪或以其它方式骚扰他人, 或通过本服务向好友或其他用户发送大量信息；</span>
      <span>(7)	将任何广告、推广信息、促销资料、“垃圾邮件”、“滥发信件”、“连锁信件”、“直销”或其它任何形式的劝诱资料加以上载、传送或分享；供前述目的使用的专用区域或专用功能除外；</span>
      <span>(8)	本服务仅为用户健康目的及日常使用目的设计，仅为用户提供在线健康咨询服务，不提供任何医疗诊断服务，且相关服务结果仅作为参考，您不可将本服务用于包括但不限于核设施、军事用途、医疗诊断、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，移视不承担法律责任；</span>
      <span>(9)	进行任何超出正常的用户之间内部或外部信息沟通、交流等目的的行为；</span>
      <span>(10)	出于超出用户之间内部或外部信息沟通、交流等目的（包括但不限于为发送广告、垃圾、骚扰或违法违规等信息的目的），通过本服务向其他用户发送大量信息；</span>
      <span>(11)	违反遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的行为；</span>
      <span>(12)	从事任何违反中国法律、法规、规章、政策及规范性文件的行为。</span>
      <span>5.	您承诺不对本软件和服务从事以下行为：</span>
      <span>(1)	将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、张贴、发送电子邮件或以其他方式传送；</span>
      <span>(2)	干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；</span>
      <span>(3)	通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</span>
      <span>(4)	通过非移视开发、授权的第三方软件、插件、外挂、系统，登录或使用软件及服务，或制作、发布、传播上述工具；</span>
      <span>(5)	自行、授权他人或利用第三方软件对本软件及其组件、模块、数据等进行干扰。</span>
      <span>6.	您承诺，使用移视服务时您将严格遵守本协议的全部内容。</span>
      <span>7.	您同意并接受移视无须时时监控您上载、传送或分享的资料及信息，但移视有权对您使用服务的情况进行审查、监督并采取相应行动，包括但不限于删除信息、中止或终止服务，及向有关机关报告。</span>
      <span>8.	您承诺不以任何形式使用本服务侵犯移视的商业利益，或从事任何可能对移视造成损害或不利于移视的行为。</span>
      <span>9.	您了解并同意，在移视服务提供过程中，移视及其关联公司或其授权单位和个人有权以各种方式投放各种商业性广告或其他任何类型的推广信息，同时，您同意接受以手机短信、电子邮件或其他方式向您发送的上述广告或推广信息。</span>
      <span>10.	您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容、使用本服务购买商品/服务的行为以及由此产生的任何后果。您应对使用本服务时接触到的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。移视无法且不会对您因前述风险而导致的任何损失或损害承担责任。</span>
      <span>11.	如果移视发现或收到他人举报您有违反本协议约定的，移视有权不经通知随时对相关内容进行删除、屏蔽，并采取包括但不限于收回账号，限制、暂停、终止您使用部分或全部本服务，追究法律责任等措施。</span>
      <br>
      <b>六、 服务费用</b><br>
      <span>1.	本服务的任何免费试用或免费功能和服务不应视为移视放弃后续收费的权利。移视有权提前7天以公告形式通知您收费标准，若您继续使用则需按移视公布的收费标准支付费用。</span>
      <span>2.	所有费用需通过移视接受的支付方式事先支付。前述使用费不包含其它任何费用或相关汇款等支出，否则您应补足付款或自行支付该费用。</span>
      <span>3.	移视有权根据实际情况提前7天单方调整费用标准及收费方式，并以公告形式通知您，而无需获得您的事先同意，如您不同意收费应当立即停止服务的使用，否则您继续使用移视服务或进行任何服务平台活动，则视为您已同意并应当缴纳费用。</span>
      <span>4.	您应当自行支付使用本服务可能产生的上网费以及其他第三方收取的通讯费、信息费等。</span>
      <span>5.	您理解并同意，在使用本软件中的服务需要进行语音/视频服务时，移视方需通过电信运营商提供的网络提供服务，运营商在某些情况下可能向用户收取一定通信费用（如用户处于异地漫游状态时需支付漫游接听费用）。</span>
      <span>6.	您理解并知悉，您在使用服务平台部分服务时，包括音频、视频等服务时，需要消耗您的流量，移视会对此作出提示，您继续使用服务视为您对消耗流量的同意。</span>
      <br>
      <b>七、 特别授权</b><br>
      <span>1.	当您向移视关联公司作出任何形式的承诺，且相关公司已确认您违反了该承诺，则移视有权立即按您的承诺约定的方式对您的账户采取限制措施，包括但不限于中止或终止向您提供服务，并公示相关公司确认的您的违约情况。您了解并同意，移视无须就相关确认与您核对事实，或另行征得您的同意，且移视无须就此限制措施或公示行为向您承担任何的责任。</span>
      <span>2.	一旦您违反本协议或与移视签订的其他协议的约定，移视有权以任何方式通知移视关联公司，要求其对您的权益采取限制措施，包括但不限于要求移视关联公司中止、终止对您提供部分或全部服务，且在其经营或实际控制的任何网站公示您的违约情况。</span>
      <br>
      <b>八、 第三方服务</b><br>
      <span>1.	移视允许第三方服务接入服务平台，您可以在移视直接获得第三方服务。您了解并同意，移视仅作为服务平台提供者，相关服务由该第三方独立提供，移视不对您对该服务的使用承担任何责任。</span>
      <span>2.	您了解并同意，如移视对服务或其部分做出调整、中止或终止而对第三方服务产生影响，移视不承担任何责任。</span>
      <span>3.	您使用服务平台接受第三方服务时，移视可能会调用第三方系统或者通过第三方支持您的使用或访问，使用或访问的结果由该第三方提供。</span>
      <br>
      <b>九、 服务中止或终止</b><br>
      <span>1.	您同意，鉴于互联网服务的特殊性，移视有权随时中止、终止或致使中止终止服务或其任何部分；对于免费服务之中止或终止，移视无需向您发出通知。</span>
      <span>2.	您了解并同意，移视可能定期或不定期地对提供网络服务的服务平台设备、设施和软硬件进行维护或检修，如因此类情况而造成收费服务在合理时间内中止，移视无需承担责任，但应尽可能事先进行通告。</span>
      <span>3.	如存在下列违约情形之一，移视可立即对用户中止或终止服务，并要求用户赔偿损失：</span>
      <span>(1)	用户违反第四条注册及账号管理之规定；</span>
      <span>(2)	用户使用收费网络服务时未按规定支付相应服务费；</span>
      <span>(3)	用户违反第五条服务使用规范之规定。</span>
      <br>
      <b>十、 隐私政策</b><br>
      <span>1.	您在服务平台注册的账户具有密码保护功能，以确保您基本信息资料的安全，请您妥善保管账户及密码信息。</span>
      <span>2.	移视努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您存储在服务平台中的信息和通信内容不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。移视会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，移视将在任何时候尽力做到使您的信息不被泄漏、毁损或丢失， 但同时也请您注意在信息网络上不存在绝对完善的安全措施，请妥善保管好相关信息。</span>
      <span>3.	移视有权根据实际情况自行决定您在本软件及服务中数据的最长储存期限、服务器中数据的最大存储空间等，您应当保管好终端、账号及密码，并妥善保管相关信息和内容，移视对您自身原因导致的数据丢失或被盗以及在本软件及服务中相关数据的删除或储存失败不承担责任。</span>
      <span>4.	其他隐私条款见《隐私政策条款》。</span>
      <br>
      <b>十一、 知识产权</b><br>
      <span>1.	您了解及同意，除非移视另行声明，本协议项下服务包含的所有产品、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利均归移视或其关联公司所有。</span>
      <span>2.	您应保证，除非取得移视书面授权，对于上述权利您不得（并不得允许任何第三人）实施包括但不限于出租、出借、出售、散布、复制、修改、转载、汇编、发表、出版、还原工程、反向汇编、反向编译，或以其它方式发现原始码等的行为。</span>
      <span>3.	移视服务涉及的Logo、“移视”等文字、图形及其组成，以及移视其他标识、徵记、产品和服务名称均为移视及其关联公司在中国和其它国家的商标或商业标识，用户未经移视书面授权不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用、或作其他处理。</span>
      <span>4.	您理解并同意授权移视在宣传和推广中使用您的名称、商标、标识，但仅限于表明您属于我们的客户或合作伙伴。</span>
      <br>
      <b>十二、 有限责任</b><br>
      <span>1.	移视在此明确声明对服务不作任何明示或暗示的保证，包括但不限于对服务的可适用性，没有错误或疏漏，持续性，准确性，可靠性，适用于某一特定用途之类的保证，声明或承诺。</span>
      <span>2.	移视对服务所涉的技术和信息的有效性，准确性，正确性，可靠性，质量，稳定，完整和及时性均不作承诺和保证。</span>
      <span>3.	不论在何种情况下，移视均不对由于Internet连接故障，电脑，通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，不可抗力，战争，政府行为，国际、国内法院的命令或第三方的不作为而造成的不能服务或延迟服务承担责任。</span>
      <span>4.	不论是否可以预见，不论是源于何种形式的行为，移视不对由以下原因造成的任何特别的，直接的，间接的，惩罚性的，突发性的或有因果关系的损害或其他任何损害（包括但不限于利润或利息的损失，营业中止，资料灭失）承担责任。</span>
      <span>(1)	使用或不能使用服务；</span>
      <span>(2)	通过服务购买或获取任何产品，样品，数据，信息或进行交易等，或其他可替代上述行为的行为而产生的费用；</span>
      <span>(3)	未经授权的存取或修改数据或数据的传输；</span>
      <span>(4)	第三方通过服务所作的陈述或行为；</span>
      <span>(5)	其它与服务相关事件，包括疏忽等，所造成的损害。</span>
      <span>5.	您充分了解并同意，鉴于互联网体制及环境的特殊性，您在服务中分享的信息及个人资料有可能会被他人复制、转载、擅改或做其它非法用途；您在此已充分意识此类风险的存在，并确认此等风险应完全由您自行承担，移视对此不承担任何责任。</span>
      <span>6.	您了解并同意，在使用服务过程中可能存在来自任何他人的包括威胁性的、诽谤性的、令人反感的或非法的内容或行为或对他人权利的侵犯（包括知识产权）及匿名或冒名的信息的风险，基于服务使用规范所述，该等风险应由您自行承担，移视对此不承担任何责任。</span>
      <br>
      <b>十三、 违约责任及赔偿</b><br>
      <span>1.	如果移视发现或收到他人举报您有违反本协议约定的，移视有权不经通知随时对相关内容进行删除、屏蔽，并采取包括但不限于限制、暂停、终止您使用服务平台账号及部分或全部服务，采取追究法律责任等措施。</span>
      <span>2.	您同意，由于您通过服务上载、传送或分享之信息、使用本服务其他功能、违反本协议、或您侵害他人任何权利因而衍生或导致任何第三人向移视及其关联公司提出任何索赔或请求，或移视及其关联公司因此而发生任何损失，您同意将足额进行赔偿（包括但不限于合理律师费、诉讼费以及因维权而发生的其他合理费用）。</span>
      <br>
      <b>十四、 有效通知</b><br>
      <span>1.	移视向您发出的任何通知，可采用手机短信、电子邮件、页面公开区域公告、个人网络区域提示或常规信件等方式，且该等通知应自发送之日视为已向用户送达或生效。</span>
      <span>2.	您同意，您向移视发出的任何通知应发至服务平台对外正式公布的电子邮件、通信地址、传真号码等联系信息，或使用其他移视认可的其他通知方式进行送达。</span>
      <br>
      <b>十五、 争议解决及其他</b><br>
      <span>1.	本协议之解释与适用，以及与本协议有关的争议，均应依照中华人民共和国法律予以处理，并以移视所在地有管辖权的法院为第一审管辖法院。</span>
      <span>2.	如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余部份则仍具有法律效力。</span>
      <span>3.	移视于用户过失或违约时放弃本协议规定的权利的，不得视为其对用户的其他或以后同类之过失或违约行为弃权。</span>
      <span>4.	本协议应取代双方此前就本协议任何事项达成的全部口头和书面协议、安排、谅解和通信。</span>
      <span>5.	移视有权根据业务调整情况将本协议项下的全部权利义务一并转移给其关联公司或其他第三方，转让将以本协议规定的方式通知，用户承诺对此不持有异议。</span>
    
    </section>
    
    <div class="article-other">
        <span>移视科技</span>
        <span>2020-06-19</span>
    </div>
        <div class="height100"></div>
  </div>
</template>

<script>
    export default {
        name: "article-details",
        data() {
            return {
                title: '用户服务协议',
                data: {},
            }
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                // this.getList()
            }
        },
        watch: {
            '$route'() {
                this.init()
            }
        },
        
        metaInfo () {
            return {
                title: this.title,
            }
        },
    }
</script>

<style scoped lang="scss">
  .body {
    width: 100%;
    height: 100%;
    padding: 1rem;
    color: #868686;
  }
  
  .privacy-content {
    overflow: hidden;
    font-size: .7rem;
    color: #666;
    line-height: 1.4rem;
    letter-spacing: 1px;
    
    .privacy-content-title {
      display: inline-block;
      width: 100%;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      padding-bottom: .6rem;
    }
    
    span {
      text-indent: 1rem;
      display: block;
    }
  }
  .article-other{
      font-size: .6rem;
      overflow: hidden;
      line-height: .6rem;
      padding: .5rem 0;
      span{
          float: right;
          margin-left: .5rem;
      }
  }
</style>
